"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getPriceOfferUrlData = (currentDisplayedPriceOffer) => {
    const offerId = currentDisplayedPriceOffer.priceOfferId;
    const { subscriptionOfferId } = currentDisplayedPriceOffer;
    const args = {
        subscriptionCarOfferId: subscriptionOfferId,
        priceOfferId: offerId,
    };
    return args;
};
exports.default = getPriceOfferUrlData;
